import {
  ContentLayout,
  CustomeDialog as CustomDialog,
  CustomTable,
  HeaderBreadcrumbs,
  CustomeDialog,
} from "../../../shared";
import * as React from "react";
import { Button, TextField, Stack, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import InputControl from "../../../shared/components/InputControl";
import { useReportsSettings } from "../hooks/useReportSettings";
import CloseIcon from "@mui/icons-material/Close";

export const ReportSettingsList = () => {
  const {
    state,
    handleModal,
    handleInputChange,
    onSubmitClassName,
    onSubmitCategory,
    handleFilterList,
  } = useReportsSettings();
  const {
    isLoading,
    classesDataList,
    categoriesDataFilteredList,
    isOpenClassName,
    isOpenCategory,
    className,
    classId,
    categoryName,
    filterClassId,
  } = state;

  const classesOptions = classesDataList.map((classItem) => ({
    value: classItem.id,
    label: classItem.name,
  }));

  const classesColumns = React.useMemo(
    () => [
      {
        Header: "Class Name",
        accessor: "name",
      },
    ],
    []
  );

  const categoriesColumns = React.useMemo(
    () => [
      {
        Header: "Category",
        accessor: "name",
      },
      {
        Header: "Class Name",
        accessor: "class.name",
      },
    ],
    []
  );

  const tabs = React.useMemo(
    () => [
      {
        label: "Class Names",
        value: "1",
        panel: (
          <CustomTable
            data={classesDataList}
            columns={classesColumns}
            isLoading={isLoading}
            filterContent={
              <Button
                type="button"
                variant="contained"
                sx={{ minWidth: "fit-content" }}
                startIcon={<AddIcon />}
                onClick={() => handleModal("className", true)}
              >
                New Class Name
              </Button>
            }
          />
        ),
      },
      {
        label: "Categories",
        value: "2",
        panel: (
          <CustomTable
            data={categoriesDataFilteredList}
            columns={categoriesColumns}
            isLoading={isLoading}
            filterContent={
              <Button
                type="button"
                variant="contained"
                sx={{ minWidth: "fit-content" }}
                startIcon={<AddIcon />}
                onClick={() => handleModal("category", true)}
              >
                New Category
              </Button>
            }
            filterSection={
              <Stack
                direction="row"
                justifyContent="space-between"
                width="100%"
              >
                <InputControl
                  type="dropdown"
                  options={classesOptions}
                  value={
                    classesOptions?.find(
                      (classItem) => classItem.value === filterClassId
                    ) ?? null
                  }
                  onChange={(e, newValue) => {
                    handleFilterList(newValue?.value);
                  }}
                  sx={{ width: 250 }}
                  renderInput={(params) => (
                    <TextField {...params} label="Class Name" required />
                  )}
                />
                <Button
                  type="button"
                  size="small"
                  variant="text"
                  color="gray"
                  sx={{
                    width: "40px",
                    height: "40px",
                    p: "8px",
                  }}
                    onClick={() => handleFilterList(null)}
                >
                  <CloseIcon />
                </Button>
              </Stack>
            }
          />
        ),
      },
    ],
    [isLoading, categoriesDataFilteredList, classesDataList]
  );

  return (
    <>
      <ContentLayout
        breadcrumbs={
          <HeaderBreadcrumbs
            heading=""
            links={[
              { name: "Dashboard", href: "/" },
              { name: "Report Settings" },
            ]}
          />
        }
        title="Report Settings"
        tabProps={{
          label: "reportSettings",
          list: tabs,
        }}
      >
        <CustomeDialog
          open={isOpenClassName}
          handleClose={() => handleModal("className", false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { width: "423px", minHeight: "210px", p: "16px" },
          }}
          title="New Class Name"
          content={
            <Stack
              sx={{
                gap: "24px",
                padding: "40px 8px 0px",
              }}
            >
              <InputControl
                name="className"
                label="Class Name"
                value={className}
                onChange={handleInputChange}
                required
              />
              <Button
                variant="contained"
                disabled={className === ""}
                onClick={onSubmitClassName}
              >
                Create
              </Button>
            </Stack>
          }
        />
        <CustomeDialog
          open={isOpenCategory}
          handleClose={() => handleModal("category", false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { width: "423px", minHeight: "210px", p: "16px" },
          }}
          title="New Category"
          content={
            <Stack
              sx={{
                gap: "24px",
                padding: "40px 8px 0px",
              }}
            >
              <InputControl
                type="dropdown"
                options={classesOptions}
                value={
                  classesOptions?.find(
                    (classItem) => classItem.value === classId
                  ) ?? null
                }
                disableClearable={true}
                onChange={(e, newValue) => {
                  handleInputChange({
                    target: {
                      name: "classId",
                      value: newValue?.value ?? newValue,
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Class Name" required />
                )}
              />
              <InputControl
                name="categoryName"
                label="Category"
                value={categoryName}
                onChange={handleInputChange}
                required
                disabled={classId === null}
              />
              <Button
                variant="contained"
                disabled={categoryName === ""}
                onClick={onSubmitCategory}
              >
                Create
              </Button>
            </Stack>
          }
        />
      </ContentLayout>
    </>
  );
};
